import sensors from "sa-sdk-javascript";
// import store from "@/store";
import { isDev, isLocalServer } from "@utils/utils";
import { CLIENT_ID, SENSORS_SERVER_URL } from "@/configs";

// 文档: https://manual.sensorsdata.cn/sa/latest/zh_cn/tech_sdk_client_web-1573905.html
// 插件: https://manual.sensorsdata.cn/sa/latest/zh_cn/tech_sdk_client_web_plugin-17571615.html

function initSensors() {
  /** 插件-页面浏览时长, 内置插件无需引入 */
  sensors.use("PageLeave", {
    // custom_props: {
    //   prop1: "value1",
    // },
    heartbeat_interval_time: 5, // 心跳记录刷新时间, 单位:s
    max_duration: 5 * 24 * 60 * 60, // 最大页面浏览时长, 单位:s
    isCollectUrl: function (url) {
      // url 为要采集页面浏览时长的页面地址。
      return true; // 采集
      // return false; // 不采集
    },
  });
  /** 插件-页面加载时长 */
  sensors.use("PageLoad", {
    max_duration: 120, // 最大页面加载时长, 单位:s
  });

  // SDK 初始化
  sensors.init({
    // https://manual.sensorsdata.cn/sa/latest/zh_cn/tech_sdk_client_web_api-7538088.html
    server_url: SENSORS_SERVER_URL,
    is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
    use_client_time: true,
    /** 'image' 图片 get 请求方式发数据。( 神策系统 1.10 版本以后 ) 支持使用 'ajax' 和 'beacon' 方式发送数据，这两种默认都是 post 方式，beacon 方式兼容性较差 */
    send_type: "image",
    heatmap: {
      /**
       * 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
       * 默认只有点击 a input button textarea 四种元素时，才会触发 $WebClick 元素点击事件
       */
      clickmap: "default",
      /**
       * 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
       * 如果发生页面滚动时候，之前的页面停留是有效停留，也就是超过默认的 4 秒或者自定义的时间，javascript SDK 就会发送一次页面停留事件。
       * 关闭页面时，发送一次页面停留事件。 神策 $WebStay 事件的采集是基于在 window 上绑定的 scroll 事件，如果页面滚动是绑定在 div 上，则无法采集。
       */
      scroll_notice_map: "default",
    },
    show_log: false, // 是否展示log
  });

  // 对于所有事件都需要添加的属性，可在初始化 SDK 后，调用 registerPage() 将属性注册为公共属性：
  sensors.registerPage({
    ClientId: CLIENT_ID,
  });

  // 设置之后，SDK 就会自动收集页面浏览事件，以及设置初始来源。
  sensors.quick("autoTrack"); //用于采集 $pageview 事件。
}

// // 非本地开发 && 非欧洲, 加神策埋点
// if (!isDev() && !store.state.isInEurope) {
//   initSensors();
// }

function init() {
  if(isDev()) return; // 开发环境不加神策埋点
  if(isLocalServer()) return // 本地服务不加神策埋点

  initSensors();
}

init()

export default sensors;
